import { defineComponent, onMounted, onUnmounted } from 'vue';
import { MultiSelect } from '@studyportals/multiselect';
import LoadingWrapper from '@/presentation/components/shared/loading-wrapper/loading-wrapper.vue';
import DeliveryModeCode from '@/presentation/components/campaign-settings/delivery-mode/delivery-mode.code';

export default defineComponent({
	components: {
		LoadingWrapper,
		MultiSelect
	},
	setup: () => {
		const code = new DeliveryModeCode();

		onMounted(code.mounted.bind(code));
		onUnmounted(code.unmounted.bind(code));

		return {
			deliveryModeDropdown: code.deliveryModeDropdown,
			options: code.options,
			isDeliveryModeEvenly: code.isDeliveryModeEvenly,
			overPerformanceLimit: code.overPerformanceLimit,
			isLoading: code.isLoading,
			validationMessage: code.validationMessage,
			isFieldValidatedAndMissing: code.isFieldValidatedAndMissing,
			isFieldValidatedAndInvalid: code.isFieldValidatedAndInvalid,
			setDeliveryMode: code.setDeliveryMode.bind(code),
			setOverPerformanceLimitBasedOnEvent: code.setOverPerformanceLimitBasedOnEvent.bind(code)
		};
	}
});
